import { useCallback } from 'react';
import { useStoreWithEqualityFn } from 'zustand/traditional';
import { shallow } from 'zustand/shallow';

import { videosStore, type VideosStoreState } from './VideosStore';
import { selectData, selectById } from '../selectors.ts';

import { useAttach } from '../useAttach';

export function useVideosData() {
  useAttach(videosStore, 'useVideosData');
  return useStoreWithEqualityFn(videosStore.store, selectData, shallow);
}
useVideosData.store = videosStore;

export function useVideosById() {
  useAttach(videosStore, 'useVideosById');
  return useStoreWithEqualityFn(videosStore.store, selectById, shallow);
}
useVideosById.store = videosStore;

export function useVideo({ videoId }: { videoId?: string }) {
  useAttach(videosStore, 'useVideo');

  const select = useCallback(
    (state: VideosStoreState) => {
      if (!videoId) {
        return {
          video: null,
          videoInstance: null,
        };
      }

      return {
        video: state.byId?.[videoId] ?? null,
        videoInstance: state.data?.[videoId] ?? null,
      };
    },
    [videoId]
  );

  return useStoreWithEqualityFn(videosStore.store, select, shallow);
}
useVideo.store = videosStore;

export function useVideosAttach() {
  useAttach(videosStore, 'useVideosAttach');
}
useVideosAttach.store = videosStore;
